<script>
export default {
    name: "ReceiveDepositForm",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    components: {

        "reverse-invoice-form": () => import('./tabs/ReverseInvoice.vue'),
        "reverse-payment-form": () => import('./tabs/ReversePayment.vue'),
        "reverse-deposit-form": () => import('./tabs/ReverseDeposit.vue'),
        "reverse-bill-form": () => import('./tabs/ReverseBill.vue'),
        "reverse-combined-invoice-form": () => import('./tabs/ReverseCombinedInvoice.vue'),
        "reverse-mpesa-payment-form": () => import('./tabs/ReverseDirectMpesaPayment.vue'),
    },
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                <div class="flex w-full -p-4">
                    <h5 class="font-semibold">Reversals</h5>
                </div>
              </template>
              <template v-slot:card-body>
                <div class="flex flex-col p-tiny">
                    <ul class="w-full flex border-b-2 border-gray-400">
                        <li class="-mb-px mr-1">
                          <a href="javascript:void(0)" @click.prevent="active=0"
                            class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
                            :class="active===0 ? activeClass : inActiveClass">Reverse Invoice</a>
                        </li>
                        <li class="-mb-px mr-1">
                          <a href="javascript:void(0)" @click.prevent="active=1"
                            class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
                            :class="active===1 ? activeClass : inActiveClass">Reverse Bills</a>
                        </li>
                        <li class="-mb-px mr-1">
                          <a href="javascript:void(0)" @click.prevent="active=2"
                            class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
                            :class="active===2 ? activeClass : inActiveClass">Reverse Payment</a>
                        </li>
                        <li class="-mb-px mr-1">
                          <a href="javascript:void(0)" @click.prevent="active=3"
                            class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
                            :class="active===3 ? activeClass : inActiveClass">Reverse Deposits</a>
                        </li>
                        <li class="-mb-px mr-1">
                          <a href="javascript:void(0)" @click.prevent="active=4"
                            class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
                            :class="active===4 ? activeClass : inActiveClass">Reverse Combined Invoice</a>
                        </li><li class="-mb-px mr-1">
                          <a href="javascript:void(0)" @click.prevent="active=5"
                            class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
                            :class="active===5 ? activeClass : inActiveClass">Reverse Mpesa Payment Allocation</a>
                        </li>
                       
                    </ul>
                    <div class="w-full mt-1" v-if="active===0">
                        <reverse-invoice-form />
                    </div>
                    <div class="w-full mt-1" v-if="active===1">
                        <reverse-bill-form />
                    </div>
                    <div class="w-full mt-1" v-if="active===2">
                        <reverse-payment-form />
                    </div>
                    <div class="w-full mt-1" v-if="active===3">
                        <reverse-deposit-form />
                    </div>
                    <div class="w-full mt-1" v-if="active===4">
                        <reverse-combined-invoice-form/>
                    </div>  
                    <div class="w-full mt-1" v-if="active===5">
                        <reverse-mpesa-payment-form/>
                    </div> 
                </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>
